import { ImprovedIcon, NotImprovedIcon, CrownIcon, ZeroIcon, CrossedLimitIcon } from 'assests/GmsIcons';
import React from 'react';

type TResultStatusProps = {
    status?: string;
    modelName: string;
}

const getIconBasedOnStatus = (status?: string,) => { 
    if (!status) return null;
    
    switch (status) {
        case 'won':
            return <CrownIcon />;
        case 'crossed_limit':
            return <CrossedLimitIcon />;
        case 'improved':
            return <ImprovedIcon />;
        case 'not_improved':
            return <NotImprovedIcon />;    
        case 'zero':
            return <ZeroIcon />;    
        default:
            return null;
    }
};

const ResultStatus = ({status, modelName} : TResultStatusProps) => {
    const icon = getIconBasedOnStatus(status);

    return (
        <div className="tw-flex tw-items-center tw-gap-1 tw-rounded">
            {status && <span className="">{icon}</span>}
            <span className="tw-text-sm tw-text-[#090A42] tw-py-1 tw-rounded">
                {modelName}
            </span>
        </div>
    );
}

export default ResultStatus;
